const goprod=false;
export function getWsUrl(path:string){
    if(window.location.hostname=='localhost'){
       return `http://localhost:3069${path}`;
    }else{
        return `wss://team.iatechfinanceira.com${path}`;
    }
}
